import { useEffect } from "react";
import EmailLog from "../../../components/EmailLog/EmailLog";

function EmailsTab(props) {
    useEffect(() => {
        if (props?.panelActionRequest?.type === "Compose") {
            props?.onEmailStartCompose?.();
        }
    }, [props?.panelActionRequest?.nonce]);

    return <EmailLog {...props} />;
}

export default EmailsTab;